module.exports = __webpack_public_path__ + "static/media/YM19_0.461922b1.jpg";